import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Label, Row } from 'reactstrap';
import CBToolTip from '../../../components/CBToolTip';

const CustomPlatformSettings = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [websiteKeys, setWebsiteKeys] = useState([]);
	const [copyTexts, setCopyTexts] = useState({
		apiKey: "Copy to clipboard",
		feedUrl: "Copy to clipboard",
	});

	// Hardcoded keys in the order they should be displayed
	const hardcodedKeys = [
		{ key: 'apiKey', label: 'Api Key' },
		{ key: 'feedUrl', label: 'Feed Url' },
	];

	useEffect(() => {
		// Get websiteKeys from location state
		if (location.state && location.state.websiteKeys) {
			setWebsiteKeys(location.state.websiteKeys);
		} else {
			// If no websiteKeys in state, redirect back to custom form
			navigate("/getStarted/custom", { replace: true });
		}
	}, [location.state, navigate]);

	// Get value for a specific key from websiteKeys array
	const getValueForKey = (keyName) => {
		const keyItem = websiteKeys.find(item => item.websiteIntegrationKey === keyName);
		return keyItem ? keyItem.websiteIntegrationValue || "" : "";
	}

	const handleCopy = (key, value) => {
		if (value) {
			navigator.clipboard.writeText(value).then(() => {
				setCopyTexts(prev => ({
					...prev,
					[key]: "Copied"
				}));
				setTimeout(() => {
					setCopyTexts(prev => ({
						...prev,
						[key]: "Copy to clipboard"
					}));
				}, 2000);
			}).catch(err => {
				console.error('Failed to copy text: ', err);
			});
		}
	}

	return (
		<>
			<section className='choosePlatformHeader'>
				<div className='container'>
					<Row className="align-items-center justify-content-center">
						<Col xs={"auto"}>
							<h2 className='mt-5'>Custom Platform Settings</h2>
						</Col>
					</Row>
				</div>
			</section>
			<section className='shopifyAppInstallationGuide mt-5'>
				<div className='container'>
					<Row className='align-items-center justify-content-center'>
						<Col xs={12} lg={4}>
							<div className='cardDisplay cardDisplayBody'>
								<div className='d-flex flex-column' style={{ minHeight: '100%' }}>
									<h3 className="cbDisplaySmall fw-semi-bold mb-4">Custom Platform Settings</h3>
									<p className="cbSubduedText mb-4">Use the following keys and values for your custom platform integration.</p>
									{hardcodedKeys.map((keyConfig) => {
										const value = getValueForKey(keyConfig.key);
										return (
											<div key={keyConfig.key} className="py-1 mt-2 copyTextInputWrap">
												<Label className="fw-bold mb-2">{keyConfig.label}</Label>
												<div className="relative maxW450">
													<div className="cbInput cbGroup cbInputMedium cbBorderGrey">
														<input 
															className="mx-3 cbNoSearchInputDecoration" 
															type="text" 
															id={`${keyConfig.key}Input`}
															ariaInvalid="false" 
															readOnly 
															value={value} 
														/>
													</div>
													<Button 
														color='link' 
														className="copyButton" 
														ariaLabel="Copy to clipboard" 
														onClick={() => handleCopy(keyConfig.key, value)}
													>
														<CBToolTip item={{ placement: 'top', text: copyTexts[keyConfig.key] || "Copy to clipboard" }} id={`${keyConfig.key}Tooltip`}>
															<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
																<rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect>
																<path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
															</svg>
														</CBToolTip>
													</Button>
												</div>
											</div>
										);
									})}
									<div className="d-flex justify-content-end mt-auto pt-4">
										<Button 
											color='primary' 
											className='cta autoWidth' 
											onClick={() => navigate("/user/dashboard")}
										>
											Go to Dashboard
										</Button>
									</div>
								</div>
							</div>
						</Col>
					</Row>
				</div>
			</section>
		</>
	);
}

export default CustomPlatformSettings;

